import {createContext} from 'react';
const TimeSlotContext = createContext();
export default TimeSlotContext;
